import Box from '@mui/material/Box';
import React from 'react';

const ListContent = React.forwardRef<
    HTMLElement,
    {
        data: any;
        overflowState?: boolean;
        setData: any;
        Component: React.ComponentType<any> | React.ReactNode;
        setDisplayCustomerActions?: any;
        singleRowGap?: number;
        setOpenDrawer?: any;
        outsideHooks?:any
    }
>(({ data, setData, Component, setDisplayCustomerActions, overflowState = true, singleRowGap = 1, setOpenDrawer, outsideHooks }, ref) => {
    if (!Component) {
        return <p style={{ color: 'black', textAlign: 'center' }}>ללא תוצאות</p>;
    }

    // Helper function to render the component properly
    const renderComponent = () => {
        if (typeof Component === 'function') {
            return setDisplayCustomerActions ? (
                <Component setOpenDrawer={setOpenDrawer} data={data} setDisplayCustomerActions={setDisplayCustomerActions}  outsideHooks={outsideHooks}/>
            ) : (
                <Component setOpenDrawer={setOpenDrawer} data={data} setData={setData} outsideHooks={outsideHooks}/>
            );
        }
        return Component; // If it's JSX, render it directly
    };

    // Pixel row-gap: nested flex + height:100% on iOS often collapses MUI theme-based gap between fragment children.
    const g = singleRowGap ?? 1;
    const rowGapPx = g <= 0 ? 0 : g <= 1 ? 10 : Math.max(10, g * 8);

    return (
        <Box
            ref={ref}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flex: 1,
                minHeight: 0,
                height: '100%',
                overflowY: overflowState ? 'auto' : 'visible',
                overflowX: 'hidden',
                WebkitOverflowScrolling: 'touch',
                rowGap: `${rowGapPx}px`,
                boxSizing: 'border-box',
                padding: singleRowGap !== 1 ? '8px 12px 0 12px' : '8px 12px 12px 12px',
                '&::-webkit-scrollbar': { display: 'none' }
            }}
        >
            {renderComponent()}
        </Box>
    );
});

export default ListContent;
